var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThumbs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5H8a3 3 0 00-3 3v6m9-9h6a3 3 0 013 3v6m-9-9v18m0 0h6a3 3 0 003-3v-6m-9 9H8a3 3 0 01-3-3v-6m18 0H5",
    stroke: "#2C2D2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDVIOEM2LjM0MzE1IDUgNSA2LjM0MzE1IDUgOFYxNE0xNCA1SDIwQzIxLjY1NjkgNSAyMyA2LjM0MzE1IDIzIDhWMTRNMTQgNVYyM00xNCAyM0gyMEMyMS42NTY5IDIzIDIzIDIxLjY1NjkgMjMgMjBWMTRNMTQgMjNIOEM2LjM0MzE1IDIzIDUgMjEuNjU2OSA1IDIwVjE0TTIzIDE0SDUiIHN0cm9rZT0iIzJDMkQyRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgThumbs as ReactComponent };